import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

interface BboxProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Bbox = forwardRef<HTMLDivElement, BboxProps>(function Bbox(
    { className, style, ...props },
    ref,
) {
    return (
        <div
            ref={ref}
            className={cn(
                'absolute box-border border border-brand rounded-[5px] pointer-events-none',
                className,
            )}
            style={style}
            {...props}
        />
    );
});
